document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a.button.btn-line');
      links.forEach(function(link) {
        link.setAttribute('target', '_blank');
    });
});

const buttons = document.querySelectorAll('.shopify-payment-button__button');
buttons.forEach(button => {
  if (button.textContent.trim() === 'Buy it now') {
    button.textContent = 'compra ya';
  }
});